<template>
    <v-row dense class="mt-1 mb-8">
        <!-- PROVEEDOR -->
        <v-col cols="12" lg="4" md="4" sm="12">
            <v-card outlined>
                <v-list-item class="pt-2 pb-2 pb-lg-2 pb-md-7 px-4">
                    <v-list-item-content>
                        <v-list-item-title
                            class="text-body-1 text--text font-weight-bold"
                        >
                            {{ forma.usuario.nombre }}
                        </v-list-item-title>
                        <v-list-item-subtitle
                            class="text-body-2 font-weight-medium"
                        >
                            <span v-if="forma.id != 23">{{
                                $t("proveedor.titulo")
                            }}</span>
                            <span
                                v-else
                                style="
                                    white-space: normal;
                                    word-break: break-word;
                                "
                                >{{ $t("proveedor.drayage-exclusivo") }}</span
                            >
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        size="36"
                        class="ml-1"
                        style="border: 1px solid #f5f7f8"
                    >
                        <img :src="forma.usuario.url_logo" />
                    </v-list-item-avatar>
                </v-list-item>
            </v-card>
        </v-col>
        <!-- CONTACTO -->
        <v-col cols="12" lg="4" md="4" sm="12">
            <transition name="v-expand-x-transition">
                <v-card outlined @click="dialog2 = true">
                    <v-list-item class="pt-2 pb-2 pb-lg-2 pb-md-7 px-4">
                        <v-list-item-content>
                            <v-list-item-title
                                class="text-body-1 text--text font-weight-bold"
                            >
                                {{ $t("proveedor.contacto.titulo") }}
                            </v-list-item-title>
                            <v-list-item-subtitle
                                class="text-subtitle-2 title-format"
                            >
                                {{ $t("proveedor.contacto.subtitulo") }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar
                            size="36"
                            class="ml-1"
                            color="secondary"
                        >
                            <v-icon dark> mdi-email-outline </v-icon>
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card>
            </transition>
        </v-col>
        <!-- BANCO -->
        <v-col cols="12" lg="4" md="4" sm="12">
            <v-card
                outlined
                @click="datosDepositos"
                v-if="
                    datos_banco_nacional.length > 0 ||
                    datos_banco_extranjero.length > 0
                "
            >
                <v-list-item class="pt-2 pb-2 px-4">
                    <v-list-item-content>
                        <v-list-item-title
                            class="text-body-1 text--text font-weight-bold"
                            style="white-space: normal; word-break: break-word"
                        >
                            {{ $t("proveedor.deposito.titulo") }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-subtitle-2">
                            {{ $t("proveedor.deposito.subtitulo") }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        size="36"
                        class="ml-1"
                        color="secondary"
                    >
                        <v-icon dark> mdi-bank </v-icon>
                    </v-list-item-avatar>
                </v-list-item>
            </v-card>
        </v-col>
        <!-- DATOS BANCO PARA DEPÓSITO O TRANSFERENCIA -->
        <v-dialog v-model="dialog" scrollable max-width="480px">
            <v-card width="480">
                <v-list>
                    <v-list-item>
                        <v-list-item-content class="py-0">
                            <v-list-item-title
                                class="text-h6 text-capitalize text--text"
                                style="
                                    white-space: normal;
                                    word-break: break-word;
                                "
                            >
                                {{ $t("proveedor.deposito.titulo") }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-avatar
                            size="36"
                            class="ml-1"
                            color="secondary"
                            ><v-icon dark>
                                mdi-bank
                            </v-icon></v-list-item-avatar
                        >
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-text class="pt-5 background">
                    <v-row>
                        <v-col cols="12">
                            <v-card
                                class="white"
                                flat
                                v-if="datos_banco_nacional.length > 0"
                                ><v-card-subtitle
                                    class="text--text font-weight-bold text-uppercase"
                                    >{{
                                        $t("pago.deposito-mxn")
                                    }}</v-card-subtitle
                                >
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-row
                                        v-for="(
                                            item, i
                                        ) in datos_banco_nacional"
                                        :key="i"
                                    >
                                        <v-col
                                            cols="12"
                                            lg="4"
                                            md="4"
                                            sm="12"
                                            class="text--text text-caption font-weight-bold"
                                            >{{ item.etiqueta }}</v-col
                                        >
                                        <v-col
                                            cols="12"
                                            lg="8"
                                            md="8"
                                            sm="12"
                                            class="black--text font-weight-medium"
                                            >{{ item.valor }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card
                                class="white"
                                flat
                                v-if="datos_banco_extranjero.length > 0"
                                ><v-card-subtitle
                                    class="text--text font-weight-bold text-uppercase"
                                    >{{
                                        $t("pago.deposito-usd")
                                    }}</v-card-subtitle
                                >

                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-row
                                        v-for="(
                                            item, i
                                        ) in datos_banco_extranjero"
                                        :key="i"
                                    >
                                        <v-col
                                            cols="12"
                                            lg="4"
                                            md="4"
                                            sm="12"
                                            class="text--text text-caption font-weight-bold"
                                            >{{ item.etiqueta }}</v-col
                                        >
                                        <v-col
                                            cols="12"
                                            lg="8"
                                            md="8"
                                            sm="12"
                                            class="black--text font-weight-medium"
                                            >{{ item.valor }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex flex-row justify-center">
                    <v-btn
                        color="background"
                        class="text--text mx-2"
                        depressed
                        @click="dialog = false"
                    >
                        {{ $t("boton-cerrar") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- DATOS CONTACTO -->
        <v-dialog v-model="dialog2" scrollable max-width="480px">
            <v-card width="480">
                <v-list>
                    <v-list-item>
                        <v-list-item-content class="py-0">
                            <v-list-item-title
                                class="text-h6 text-capitalize text--text"
                            >
                                {{ $t("proveedor.contacto.titulo") }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-avatar
                            size="36"
                            class="ml-1"
                            color="secondary"
                            ><v-icon dark>
                                mdi-email-outline
                            </v-icon></v-list-item-avatar
                        >
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-card-text class="background pt-5">
                    <v-list-item>
                        <v-list-item-content class="text-center">
                            <v-list-item-title class="text-h6 text--text">{{
                                forma.usuario.contacto_nombre
                            }}</v-list-item-title>
                            <v-list-item-subtitle
                                class="text-subtitle-1 text--text text-wrap"
                                >{{
                                    forma.usuario.contacto_telefono
                                }}</v-list-item-subtitle
                            >
                            <v-list-item-action class="justify-center">
                                <v-btn
                                    depressed
                                    color="background"
                                    class="text--text"
                                    @click.stop="
                                        enviar_email(
                                            forma.usuario.contacto_correo
                                        )
                                    "
                                >
                                    {{ forma.usuario.contacto_correo }}
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item-content>
                    </v-list-item>
                </v-card-text>
                <v-card-actions class="d-flex flex-row justify-center">
                    <v-btn
                        color="background"
                        class="text--text mx-2"
                        depressed
                        @click="dialog2 = false"
                    >
                        {{ $t("boton-cerrar") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    props: {
        forma: Object,
    },
    data() {
        return {
            datosBancarios: [],
            frenteContacto: true,
            dialog: false,
            dialog2: false,
            datos_banco_nacional: this.forma.usuario.usuario_bancos,
            datos_banco_extranjero: this.forma.usuario.usuario_bancos2,
        };
    },
    methods: {
        enviar_email(correo) {
            window.location.href = "mailto:" + correo;
        },

        datosDepositos() {
            this.dialog = true;
            /*this.axios
        .get(route("forma.datos-bancarios", this.forma.id))
        .then((response) => {
          console.log(response);
          this.datosBancarios = response.data;

          // LLamadar al dialogo
        });*/
        },
    },
};
</script>
